const PRODUCT_CART = "productsCart";
export const CART_UPDATED_EVENT = "cartUpdated";

function notifyCartUpdated() {
  window.dispatchEvent(new Event(CART_UPDATED_EVENT));
}

export function getProductsCart() {
  const response = localStorage.getItem(PRODUCT_CART);
  return JSON.parse(response || "[]");
}

export function addProductCart(
  id,
  quantity = 1,
  note = "",
  optionChoice = "",
  extras = [],
  unitPrice = null,
  offerId = null,
  offerTitle = ""
) {
  const products = getProductsCart();
  products.push({
    id,
    quantity,
    note,
    optionChoice,
    extras,
    unitPrice,
    offerId,
    offerTitle,
  });
  localStorage.setItem(PRODUCT_CART, JSON.stringify(products));
  notifyCartUpdated();
}

// Opciones del mozo por línea del carrito (Admin): { takeaway, courtesy,
// courtesyReason }. No aplican al carrito del comensal.
export function updateProductCartApi(index, patch) {
  const products = getProductsCart();
  if (!products[index]) return;
  products[index] = { ...products[index], ...patch };
  localStorage.setItem(PRODUCT_CART, JSON.stringify(products));
  notifyCartUpdated();
}

export function removeProductCartApi(index) {
  const idProducts = getProductsCart();
  idProducts.splice(index, 1);
  localStorage.setItem(PRODUCT_CART, JSON.stringify(idProducts));
  notifyCartUpdated();
}

export function cleanProductCartApi() {
  localStorage.removeItem(PRODUCT_CART);
  notifyCartUpdated();
}
